import type { FC, ReactNode } from 'react'

import { Fragment } from 'react'

interface SplitCharsProps {
    text: string
    className?: string
}

// Splits a line into letters for the blur reveal. Words never break mid-word, and the
// visual letters are hidden from screen readers, so pair it with an sr-only copy.
const SplitChars: FC<SplitCharsProps> = ({ text, className }): ReactNode => {
    const words = text.split(' ')

    return (
        <span aria-hidden='true' className={className}>
            {words.map((word, wordIndex) => (
                <Fragment key={`${word}-${wordIndex}`}>
                    <span className='inline-block whitespace-nowrap'>
                        {Array.from(word).map((character, characterIndex) => (
                            <span key={characterIndex} data-char className='inline-block'>
                                {character}
                            </span>
                        ))}
                    </span>
                    {wordIndex < words.length - 1 && ' '}
                </Fragment>
            ))}
        </span>
    )
}

export default SplitChars
